import type {
  SendBulkApplicationEmailMutation,
  SendBulkApplicationEmailMutationVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import hirerGraphqlClient from './client';
import { mutation } from './schema/mutationSendBulkApplicationEmail';

interface SendBulkApplicationEmailInput {
  prospectIds: string[];
  subject: string;
  message: string;
  enableReplies: boolean;
}

export const sendBulkApplicationEmail = async (
  input: SendBulkApplicationEmailInput,
) => {
  const { data } = await hirerGraphqlClient.mutate<
    SendBulkApplicationEmailMutation,
    SendBulkApplicationEmailMutationVariables
  >({
    variables: {
      input,
    },
    mutation,
  });
  if (data === null) {
    throw new Error('graphql error sending bulk application email');
  }

  return data?.sendBulkApplicationEmail;
};
